var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3454_70564",
    maskUnits: "userSpaceOnUse",
    x: 0.199951,
    y: 0,
    width: 50,
    height: 52,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.199951,
    width: 50,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7999 23.6C47.7999 35.5294 37.592 45.2 25 45.2C22.1184 45.2 19.3617 44.6936 16.8236 43.7696L4.98601 49.9999L6.80245 36.6155C3.91348 32.996 2.19995 28.4876 2.19995 23.6C2.19995 11.6706 12.4079 2 25 2C37.592 2 47.7999 11.6706 47.7999 23.6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8236 43.7696L17.3368 42.3601C16.9393 42.2154 16.4993 42.2452 16.125 42.4422L16.8236 43.7696ZM4.98601 49.9999L3.49963 49.7981C3.4241 50.3547 3.66581 50.9068 4.12596 51.2288C4.58612 51.5508 5.18762 51.5888 5.68463 51.3272L4.98601 49.9999ZM6.80245 36.6155L8.28883 36.8172C8.34395 36.4111 8.23048 36.0001 7.97481 35.6798L6.80245 36.6155ZM25 46.7C38.343 46.7 49.2999 36.4332 49.2999 23.6H46.2999C46.2999 34.6255 36.8411 43.7 25 43.7V46.7ZM16.3105 45.1791C19.0115 46.1624 21.9418 46.7 25 46.7V43.7C22.295 43.7 19.7118 43.2247 17.3368 42.3601L16.3105 45.1791ZM5.68463 51.3272L17.5222 45.0969L16.125 42.4422L4.28739 48.6725L5.68463 51.3272ZM5.31608 36.4138L3.49963 49.7981L6.47238 50.2016L8.28883 36.8172L5.31608 36.4138ZM0.699951 23.6C0.699951 28.8467 2.54122 33.6813 5.6301 37.5513L7.97481 35.6798C5.28574 32.3107 3.69995 28.1285 3.69995 23.6H0.699951ZM25 0.5C11.6569 0.5 0.699951 10.7668 0.699951 23.6H3.69995C3.69995 12.5745 13.1588 3.5 25 3.5V0.5ZM49.2999 23.6C49.2999 10.7668 38.343 0.5 25 0.5V3.5C36.8411 3.5 46.2999 12.5745 46.2999 23.6H49.2999Z",
    fill: "#054BC7",
    mask: "url(#path-1-outside-1_3454_70564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 24.8L24.25 12.8L25 12.8L25.75 12.8L25.75 24.8L25 24.8L24.25 24.8Z",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9999 35.6C24.0058 35.6 23.1999 34.7941 23.1999 33.8C23.1999 32.8059 24.0058 32 24.9999 32C25.994 32 26.7999 32.8059 26.7999 33.8C26.7999 34.7941 25.994 35.6 24.9999 35.6Z",
    fill: "#054BC7",
    stroke: "#054BC7",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNoText);
export default __webpack_public_path__ + "static/media/help_no_text.8289d812098630acf2c669470c5bf21f.svg";
export { ForwardRef as ReactComponent };